
import { isEqual } from 'lodash'
import { getDriverData } from '../api.js'

import settings from '../settings.js'
import notifications from '../notifications.js'

const _vars = {
  currDriverData: undefined,

  getDriverDataPromise: undefined,
  getDriverDataCallback: undefined,

  currApiPromise: undefined,
  currApiParams: undefined,
}

function _getDriverDataFromServer(apiParams) {
  function _responseCallback(response) {
    _vars.currDriverData = response.data
    if (_vars.getDriverDataCallback) {
      _vars.getDriverDataCallback()
    }
  }

  function _responseError(error) {
    notifications.pushError('Unable to get driver data from server.', error)
  }

  if (_vars.currApiPromise === undefined || !isEqual(apiParams, _vars.currApiParams)) {
    _vars.currApiPromise = getDriverData(apiParams)
    _vars.currApiPromise.then(_responseCallback).catch(_responseError)
  }
  return _vars.currApiPromise
}

function _getDriverData(id) {
  if (_vars.currDriverData) {
    return Promise.resolve(_getDriverDataSync(id))
  }
  else {
    _vars.getDataPromise = new Promise((resolve) => {
      _vars.getDriverDataCallback = function () {
        resolve(_getDriverDataSync(id))
      }
    })
    return _vars.getDriverDataPromise
  }
}

function _getDriverDataSync(id) {
  if (id === undefined) {
    return _vars.currDriverData
  }

  return _vars.currDriverData.find(elem => elem.db_id === id)
}

function getNumPerPage() {
  return settings.driverList.numPerPage
}

function getCurrentPage() {
  return settings.driverList.currentPage
}

function setCurrentPage(pageNumber) {
  settings.driverList.currentPage = pageNumber
}

function _init() {
  // do nothing
}

_init()

export default {
  getDriverDataFromServer: _getDriverDataFromServer,
  getDriverData: _getDriverData,
  getDriverDataSync: _getDriverDataSync,
  getNumPerPage: getNumPerPage,
  getCurrentPage: getCurrentPage,
  setCurrentPage: setCurrentPage,
}
